<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="v_tableData"
    :row-class-name="rowClassName"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :loading="loading"
    :height="height"
    size="mini"
    resizable
    border
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
    }"
    row-id="orderBatchCode"
    :radio-config="{ highlight: true, trigger: 'row' }"
    :checkbox-config="{
      highlight: true,
      reserve: true,
    }"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:boxPriceAmount="{ row }">
      <span>{{ row.boxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
    </template>
    <template v-slot:boxSalePriceAmount="{ row }">
      <span>
        {{ row.boxSalePriceAmount || 0 }} {{ row.v_salesCurrencyUnit }}
      </span>
    </template>
    <template v-slot:batchBoxPriceAmount="{ row }">
      <span>{{ row.batchBoxPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
    </template>
    <template v-slot:batchBoxSalePriceAmount="{ row }">
      <span>
        {{ row.batchBoxSalePriceAmount || 0 }}{{ row.v_salesCurrencyUnit }}
      </span>
    </template>
    <template v-slot:errorMsg="{ row }">
      <div>
        <span v-html="row.errorMsg"></span>
      </div>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 600 },
    shipmentCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    tablePage: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      v_tableData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
      rowClassName: ({ row }) => {
        if (row.errorMsg) return 'bg-danger text-white'
        return ''
      },
    }
  },
  watch: {
    tableData: {
      handler(val) {
        if (val) this.v_tableData = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
    },
  },
  methods: {
    getCheckboxRecords() {
      const checkData = this.$refs.vxeGrid
        .getCheckboxRecords()
        .concat(this.$refs.vxeGrid.getCheckboxReserveRecords())
      if (!checkData.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      const orderBatchCodeList = checkData.map((i) => i.orderBatchCode)
      this.loadingOpen()
      this.$api
        .shipmentInfoAddShipmentPlanBatchApi({
          custCode: this.custCode,
          shipmentCode: this.shipmentCode,
          orderBatchCodeList: orderBatchCodeList,
        })
        .then((res) => {
          this.loadingClose()
          const { data } = res.body
          if (data) {
            this.$message({
              showClose: true,
              message: '数据未通过校验!',
              type: 'warning',
            })
            data.forEach((f) => {
              this.v_tableData.forEach((m) => {
                if (f.orderBatchCode == m.orderBatchCode) {
                  m.errorMsg = f.errorMsg
                }
              })
            })
            return
          }
          // 清除选中的记录
          this.$refs.vxeGrid.clearCheckboxRow()
          this.$refs.vxeGrid.clearCheckboxReserve()
          this.$emit('reload')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
